import React, { useCallback, useEffect, useState } from 'react';
import Searchbar from '../../../components/common/searchbar';
import { Pagination } from '../../../components/common';

export interface FilterOptionsType {
  [key: string]: string;
}
export interface FilterType {
  page: number;
  limit: number;
  search: string;
  filterValue: string;
}

interface FilterProps {
  count: number | undefined;
  updateFilter: (data: FilterType) => void;
  filterOptions: FilterOptionsType;
  defaultFilterValue: string;
}

const ReviewPageControls: React.FunctionComponent<FilterProps> = ({
  count,
  updateFilter,
  filterOptions,
  defaultFilterValue,
}): JSX.Element => {
  const [filters, setFilters] = useState<FilterType>({
    page: 1,
    limit: 25,
    search: '',
    filterValue: defaultFilterValue,
  });
  const triggerUpdate = useCallback(
    (updatedFilters: FilterType) => {
      updateFilter(updatedFilters);
    },
    [updateFilter],
  );

  useEffect(() => {
    triggerUpdate(filters);
  }, [filters, triggerUpdate]);

  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-7">
      <div className="w-1/4">
        <div className="h-8 w-full">
          <Searchbar
            search={(data) => {
              setFilters((prev) => {
                return { ...prev, page: 1, search: data };
              });
            }}
          />
        </div>
      </div>
      <div className="w-1/3">
        <Pagination
          pageCount={Math.ceil((count || 10) / 25)}
          key={Math.ceil((count || 10) / 25)}
          updatePageNumber={(pages) =>
            setFilters((filter) => {
              return { ...filter, page: pages + 1 };
            })
          }
        />
      </div>
      <div className="w-1/3">
        <div className="flex justify-end">
          <div className="gray-background-dark flex items-center justify-between py-4">
            {Object.keys(filterOptions).map((item: string) => (
              <button
                key={item}
                className={
                  'px-5 py-1 text-sm ' +
                  (item === filters.filterValue
                    ? 'bg-blue-primary text-white'
                    : 'bg-gray-background-dark text-gray-dark')
                }
                onClick={() => {
                  setFilters((filter: any) => {
                    return {
                      ...filter,
                      page: 1,
                      filterValue: item,
                    };
                  });
                }}
              >
                {filterOptions[item]}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewPageControls;
